import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms & Conditions', href: '/terms-conditions' }
  ]

  const socialLinks = [
    { name: 'TikTok', icon: 'tiktok.svg', href: 'https://www.tiktok.com/@loomiogames' },
    { name: 'Twitter', icon: 'x.svg', href: 'https://twitter.com/LoomioGames' },
    { name: 'YouTube', icon: 'youtube.svg', href: 'https://www.youtube.com/@LoomioGames' },
  ]

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <img src="/assets/images/logo-blue.png" alt="Logo" />
            </div>
            <div className="footer-links-inline">
              {footerLinks.map((link, index) => (
                <React.Fragment key={index}>
                  <Link to={link.href} className="footer-link">
                    {link.name}
                  </Link>
                  {index < footerLinks.length - 1 && <span className="separator"> | </span>}
                </React.Fragment>
              ))}
            </div>
            <p className="footer-copyright">© {currentYear} Loomio Gaming. All rights reserved.</p>
          </div>

          <div className="footer-social">
            <h4>
              Let's stay<br />
              <span className="highlight">connected</span>
            </h4>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.href} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.name}
                >
                  <img 
                    src={`/assets/images/social/${social.icon}`} 
                    alt={social.name} 
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
